import { useEffect, useMemo, useState } from "react";
import { dateFormatter, defaultFormattedValue } from "../helpers/dateFormatter";

interface CountDownProps {
  startAt: string | number | undefined;
};

interface CountDownResponse {
  countDownView: string;
  isCountdownEnded: boolean;
  isCountdownContinue: boolean;
}

const defaultResponse = {
  countDownView: defaultFormattedValue,
  isCountdownEnded: true,
  isCountdownContinue: false
};

export const useCountDown = ({ startAt }: CountDownProps): CountDownResponse => {
  const [nowDate, setNowDate] = useState(new Date());
  const startAtDate = useMemo(() => {
    const startAtDate = startAt ? new Date(startAt) : new Date();
    const differenceTime = startAtDate.getTime() - nowDate.getTime();

    return new Date(differenceTime);
  }, [startAt, nowDate]);

  const countDownView = dateFormatter(startAtDate);
  const isCountdownEnded = countDownView === defaultFormattedValue;
  const isCountdownContinue = countDownView !== defaultFormattedValue;

  useEffect(() => {
    const updateCountdownInterval = setInterval(() => {
      setNowDate(new Date());
    }, 1000);

    return () => {
      clearInterval(updateCountdownInterval);
    };
  }, []);

  if (!startAt) return defaultResponse;

  return {
    countDownView,
    isCountdownEnded,
    isCountdownContinue
  };
};